import React from "react"
import { connect } from "react-redux"

import NpsCommentForm from "./NpsCommentForm"
import NpsRating from "./NpsRating"
import * as actions from "../../actions"

class NpsFeedback extends React.Component {
  constructor(props) {
    super(props)
    this.onScoreClick = this.onScoreClick.bind(this)
    this.onCommentChange = this.onCommentChange.bind(this)
    this.onSubmitComment = this.onSubmitComment.bind(this)
    this.state = { rating: null, comment: null }
    this.scoreSubmitted = null
  }

  componentWillUnmount(){
    clearTimeout(this.scoreSubmitted)
  }

  onSubmitComment() {
    this.props.submitFeedback(this.state.rating, this.state.comment)
  }

  onScoreClick(rating) {
    this.scoreSubmitted = setTimeout(
      () =>
        this.setState({ rating: rating }, () => {
          this.props.submitScore(this.state.rating)
        }),
      1000
    )
  }

  onCommentChange(e) {
    this.setState({ comment: e.target.value })
  }

  render() {
    const { score, submitted } = this.props
    let view = null
    if (score)
      view = (
        <NpsCommentForm
          submitComment={() => this.onSubmitComment()}
          onChange={this.onCommentChange}
          submitted={submitted}
        />
      )
    else if (!score && !submitted)
      view = <NpsRating onScoreClick={this.onScoreClick} />
    return view
  }
}

const mapStateToProps = state => ({
  score: state.feedback.npsScore,
  submitted: state.feedback.npsSubmitted,
})

const mapDispatchToProps = {
  submitScore: actions.submitNpsScore,
  submitFeedback: actions.submitNpsFeedback,
  shouldGetFeedback: actions.shouldGetNpsFeedback,
}

const NpsFeedbackWrapper = connect(
  mapStateToProps,
  mapDispatchToProps
)(NpsFeedback)

export { NpsFeedbackWrapper as default, NpsFeedback }



// WEBPACK FOOTER //
// ./assets/feedback/components/nps/NpsFeedback.js